import { getDefaultSubscriptionFieldValues } from './qa-fixtures'

export function buildDefaultSubscriptionFieldValues (templateId: string): Record<string, string> {
  return getDefaultSubscriptionFieldValues(templateId)
}
